<template>
  <div>
    <span
      class="locale-selector"
      @click="changeLocale('en')"
      :class="{
        active: $i18n.locale === 'en',
        white: variant === 'white'
      }"
    >
      {{ $t('nav.lang.en') }}
    </span>
    <span class="mx-1 locale-selector">/</span>
    <span
      class="locale-selector"
      @click="changeLocale('zh-CN')"
      :class="{
        active: $i18n.locale === 'zh-CN',
        white: variant === 'white'
      }"
    >
      {{ $t('nav.lang.zh-cn') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',

  props: {
    variant: String
  },

  data() {
    return { langs: this.$config.supportedLocales }
  },

  methods: {
    changeLocale(locale) {
      // workaround to update OnePlace header in locale
      this.$store.dispatch('auth/changeLocale', locale)
    }
  }
}
</script>

<style lang="scss" scoped>
.locale-selector {
  cursor: pointer;

  &.active {
    font-weight: bold;
  }

  &.white {
    color: white;
  }
}
</style>
